import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationDetoxificationIntermediaryDiagramContent } from "./MethylationDetoxificationIntermediaryDiagram";
import { MethylationDetoxificationIntermediaryKeyContent } from "./MethylationDetoxificationIntermediaryKey";

const SvgMethylationDetoxificationIntermediaryDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 636, 880)}
      viewBox={diagramOnly ? "0 170 1024 636" : "0 0 1024 880"}
    >
      <g id="diagram+key" clipPath="url(#clip0_18382_42417)">
        <rect width={1024} height={diagramOnly ? 636 : 880} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationDetoxificationIntermediaryKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <MethylationDetoxificationIntermediaryDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18382_42417">
          <rect width={1024} height={880} fill="white" />
        </clipPath>
        <clipPath id="clip1_18382_42417">
          <rect width={1024} height={636} fill="white" transform="translate(0 170)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationDetoxificationIntermediaryDiagramKey;
